import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'dmv-pub-page-not-found',
    templateUrl: './page-not-found.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PageNotFoundComponent {
}
